import { combineReducers } from "@reduxjs/toolkit";

import authReducer from "@/reducers/auth";
import chat from "@/reducers/chat";
import clientCandidatesAppliedReducer from "@/reducers/client_candidates/candidatesapplied";
import clientCandidatesBookedReducer from "@/reducers/client_candidates/candidatesbooked";
import clientCandidatesInvitedReducer from "@/reducers/client_candidates/candidatesinvited";
import clientCandidatesWorkedReducer from "@/reducers/client_candidates/candidatesworked";
import clientUsersReducer from "@/reducers/client_user/clientUsers";
import clientRoleAccessReducer from "@/reducers/client_user/roleAccess";
import userAccessReducer from "@/reducers/client_user/userAccess";
import clientCandidateDetailReducer from "@/reducers/clientcandidatedetail";
import clientCommonReducer from "@/reducers/clientcommon";
// import clientLayoutReducer from '@/reducers/clientcommon';
import clientContractDetailReducer from "@/reducers/clientcontractdetail";
import clientCreateJobReducer from "@/reducers/clientcreatejob";
import clientDashboardReducer from "@/reducers/clientdashboard";
import clientInvoiceReducer from "@/reducers/clientinvoice";
import clientNotificationReducer from "@/reducers/clientnotification";
import clientProfileReducer from "@/reducers/clientprofile";
import clientsCandidatesReducer from "@/reducers/clientscandidates";
import clientUnfilledContracts from "@/reducers/clientunfilledcontracts";
import sessionReducer from "@/reducers/session";
import socket from "@/reducers/socket";
import clientTimesheetAuthorisedReducer from "@/reducers/timesheets/timesheetauthorised";
import clientTimesheetsReducer from "@/reducers/timesheets/timesheets";
import clientTimesheetSubmittedReducer from "@/reducers/timesheets/timesheetsubmitted";
import clientTimesheetTerminatedReducer from "@/reducers/timesheets/timesheetterminated";

/////////
import candidateCreateReducer from "./candidateCreate";
import clientAnnouncementReducer from "./clientAnnouncement";
import clientDownloadsReducer from "./clientDownloads";
import clientHelpReducer from "./clientHelp";
import clientInvoiceTypeReducer from "./invoicesCount";
import invoiceCreation from "./timesheets/invoicecreation";
import timesheetAssignedReducer from "./timesheets/timesheetassigned";

export default combineReducers({
  session: sessionReducer,
  auth: authReducer,
  clientProfile: clientProfileReducer,
  clientCommon: clientCommonReducer,
  clientNotification: clientNotificationReducer,
  clientsCandidates: clientsCandidatesReducer,
  clientDashboard: clientDashboardReducer,
  clientCandidatesInvited: clientCandidatesInvitedReducer,
  clientCandidatesApplied: clientCandidatesAppliedReducer,
  clientCandidatesWorked: clientCandidatesWorkedReducer,
  clientCandidatesBooked: clientCandidatesBookedReducer,
  clientCreateJob: clientCreateJobReducer,
  clientCandidateDetail: clientCandidateDetailReducer,
  clientContractDetail: clientContractDetailReducer,
  clientInvoices: clientInvoiceReducer,
  clientInvoiceCount: clientInvoiceTypeReducer,
  clientUnfilledContracts: clientUnfilledContracts,
  socket: socket,
  chat: chat,
  clientTimesheets: clientTimesheetsReducer,
  clientTimesheetSubmitted: clientTimesheetSubmittedReducer,
  clientTimesheetAuthorised: clientTimesheetAuthorisedReducer,
  clientTimesheetTerminated: clientTimesheetTerminatedReducer,
  clientUsers: clientUsersReducer,
  userAccess: userAccessReducer,
  clientRoles: clientRoleAccessReducer,
  clientAnnouncement: clientAnnouncementReducer,
  clientHelp: clientHelpReducer,
  clientDownloads: clientDownloadsReducer,
  ////////////////// NEW ADDITIONS ////////////////
  candidateCreate: candidateCreateReducer,
  timesheetAssigned: timesheetAssignedReducer,
  invoiceCreation: invoiceCreation,
});
